import { Layout, Flex } from "antd"
import './style.css'

const ScreenLayout = ({ children }) => {
    return <Layout className="screenLayout" >
        {children}
    </Layout>
}

export default ScreenLayout